/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/web_medium'
export default icon
